export const ItLocale = {
    page: {
        txtTitle: 'SHIRITORI | Impara il vocabolario giapponese online con il divertente gioco しらとり',
    },
    common: {
        txtLogoAlt: 'Treno Shiritori',
    },
    header: {
        txtLeave: 'LASCIA LA PARTITA',
    },
    dialog: {
        leave: {
            txtTitle: 'Lasciare questa partita?',
            btnStay: 'RESTA IN PARTITA',
            btnLeave: 'LASCIA E ABBANDONA',
        },
    },
    home: {
        btnNewGame: 'NUOVA PARTITA',
        btnMainMenu: 'MENU PRINCIPALE',
        btnJoinGame: 'UNISCITI',
        btnReturnToGame: 'TORNA ALLA PARTITA',
    },
    create: {
        headingNamePrompt: 'Come ti chiamiamo?',
        placeholderName: 'Il tuo nome',
        btnOk: 'OK',
    },
    join: {
        placeholderName: 'Il tuo nome',
        placeholderGameId: 'id partita',
        btnJoinGame: 'UNISCITI',
    },
    configure: {
        header: 'IMPOSTAZIONE PARTITA',
        labelExpectedPlayers: 'Numero di giocatori',
        labelBoardSize: 'Dimensione tabellone',
        labelWordList: 'Lista parole',
        labelAllowHints: 'Consenti suggerimenti',
        labelTurnTimer: 'Timer turno',
        optionNoTimer: 'Senza timer',
        optionTimer: 'Timer',
        unitSeconds: 's',
        btnStartGame: 'INIZIA',
        toastCreateError: 'Errore: impossibile creare questa partita',
        toastTryAgain: 'Errore: riprova più tardi.',
    },
    game: {
        lobby: {
            btnReady: 'Pronto',
            txtShareInvite: 'Condividi questo codice con i tuoi amici!',
            txtPlayer: 'Giocatore',
            txtTeam: 'Squadra',
        },
        message: {
            noSuchGame: 'Questa partita non esiste',
            txtLoading: 'Caricamento...',
            txtCannotJoin: 'Impossibile entrare nella partita',
        },
        gameplay: {
            board: {
                timeoutTitle: 'TEMPO',
                timeoutSubtitle: 'scaduto',
            },
            wordSearch: {
                multipleMatches: 'TROVATE PIÙ CORRISPONDENZE!',
                yourTurn: 'TOCCA A TE',
                placeholder: 'Quale parola giochiamo?',
                playAction: 'GIOCA',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: 'Parola inesistente!',
                toastCantPlay: 'Non puoi giocare quella parola!',
                toastPlayed: 'Hai giocato "{{word}}"',
                toastPlayFailed: 'Ops, impossibile giocare quella parola!',
                validation: {
                    syllableMismatch: 'La sillaba iniziale non corrisponde',
                    missingLastWord: 'L’ultimo turno non ha parola',
                    wordNotInList: 'La parola non appartiene alla lista',
                }
            },
            spectate: {
                waitingOn: 'In attesa di {{player}}',
                timeLeft: 'Tempo rimasto: {{seconds}}s',
            },
            endGame: {
                header: 'PARTITA FINITA',
                viewResults: 'VEDI RISULTATI',
                statsTotalTime: 'Tempo totale di gioco',
                statsSquaresFilled: 'Caselle riempite',
                statsLongestWord: 'Parola più lunga',
                share: 'Condividi',
                sharing: 'Condivisione...',
                ariaCloseLabel: 'Chiudi modal fine partita',
            }
        },
    },
    footer: {
        linkHowToPlay: 'Come si gioca',
        linkPrivacyPolicy: 'Informativa sulla privacy',
        txtAllRightsReserved: 'Tutti i diritti riservati.',
    },
    howToPlay: {
        title: 'Come giocare a Shiritori しりとり (shiritori)',
        btnPlayNow: 'Gioca ora!',
        btnReturnToGame: 'Torna alla partita:',
        description1: 'b|Shiritori| è la nostra versione online multiplayer del gioco giapponese a catena di parole しりとり. Costruisci un tabellone illustrato mentre alleni il vocabolario con amici o in solitaria.',
        description2: 'Crea o unisciti a una partita, scegli dimensione del tabellone, set immagini e lista parole, poi riempi la griglia con parole valide prima che qualcuno sbagli.',
        gameSetup: {
            title: 'Crea o unisciti a una partita',
            p1: 'Inizia da solo o invita fino a 9 amici (10 giocatori totali) con un link condivisibile o codice partita.',
            p2: 'Scegli le opzioni che vuoi: dimensione tabellone (3x3, 5x5, 7x7), pattern/colore sfondo, set immagini e lista parole da studiare.',
            p3: 'Gli amici aprono il link, scelgono un nickname e appaiono nella lobby; la partita inizia quando entra il numero previsto di giocatori.',
            p4: 'Chi arriva tardi può comunque guardare una partita in corso in modalità sola visualizzazione.',
        },
        objective: {
            title: 'Obiettivo',
            p1: 'Concatena parole in modo che ogni nuova inizi con l’ultima sillaba della precedente, riempi il tabellone e non terminare mai una parola con ん.',
        },
        wordRules: {
            title: 'Parole valide',
            p1: 'Scrivi in kana o romaji; il romaji viene convertito in hiragana lato client prima del controllo.',
            p2: 'Le parole devono esistere nella lista selezionata (100/1000 comuni, cibo, sport, ecc.) e mostrano il significato dopo essere state giocate.',
            p3: 'Le parole già usate vengono bloccate. Se gli omofoni sono consentiti, puoi scegliere una variazione non usata con l’immagine corretta.',
            li1: 'Inizia con la sillaba richiesta dal turno precedente',
            li2: 'Non termina con ん (n)',
            li3: 'È inclusa nella lista scelta',
            li4: 'Non è stata già giocata in questa partita',
            li5: 'Usa un omofono/immagine consentito quando la regola è attiva',
            p4: 'Ogni mossa valida inserisce la sua immagine sul tabellone in ordine, riempiendo da sinistra a destra e dall’alto in basso. e|Esempio:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Turni e tempo',
            p1: 'I turni scorrono nella lista giocatori; quando diventi attivo hai fino a 10 secondi da quando vedi il tuo turno.',
            p2: 'Shiritori aspetta che il giocatore successivo sia attivo (browser in focus) prima di avviare il conto alla rovescia, evitando salti del timer con riavvii o refresh.',
            p3: 'Inserisci la tua parola, osserva la validazione in tempo reale e invia entro la scadenza: invii invalidi o in ritardo terminano subito la partita.',
        },
        boardFlow: {
            title: 'Tabellone, flusso e fine',
            p1: 'Il tabellone mostra ogni parola giocata con immagine, nome giocatore e numero turno, con frecce che tracciano l’ordine nella griglia.',
            p2: 'Quando è il turno di qualcun altro, puoi comunque vedere sillaba iniziale richiesta e conto alla rovescia.',
            p3: 'Se tutti gli spazi vengono riempiti con parole valide, la partita termina con successo e mostra il tabellone completo da condividere.',
            p4: 'Se nessuna mossa valida viene inviata prima della scadenza, la partita termina con un riepilogo di chi è andato in timeout o ha giocato una parola non valida.',
        },
        summary: {
            title: 'Riepilogo',
            p1: 'Shiritori mantiene shiritori veloce e visivo: round rapidi, regole chiare e memorie visive aiutano tutti a tenere viva la catena.',
            p2: 'Condividi un link, riempi il tabellone e scopri fin dove può arrivare la tua catena di parole.',
        }
    },
    bugsAndFeatures: {
        title: 'Segnalazioni bug e nuove funzionalità',
        p1: 'Abbiamo creato questo gioco come modo diverso di giocare al classico k|しりとり.| Come team che ama i giochi, cerchiamo sempre modi per migliorarlo e renderlo più piacevole.',
        cta: {
            l1: 'Ci farebbe davvero piacere se potessi aiutarci ',
            a: 'condividendo il nostro gioco con i tuoi amici',
            l2: ' sui social media!'
        },
        p2: 'Se riscontri bug o hai suggerimenti per nuove funzionalità, faccelo sapere!',
        bugs: {
            title: 'Bug',
            p1: 'Segnala qualsiasi comportamento anomalo, errore o bug direttamente nel nostro a|https://github.com/indexinteractive/|repository_pubblico_GitHub| . Assicurati di includere più dettagli possibile, compresi i passaggi per riprodurre il problema.'
        },
        features: {
            title: 'Nuove funzionalità',
            p1: 'Se hai suggerimenti per nuove funzioni, miglioramenti o idee per il gioco, faccelo sapere creando una nuova discussione nella pagina a|https://github.com/indexinteractive/|GitHub_Discussions| .'
        }
    },
    share: {
        title: 'Shiritori | Impara il vocabolario giapponese online con il divertente gioco しらとり - SHIRITORI',
        text: 'Gioca a Shiritori online con amici o giocatori casuali. Nessuna registrazione richiesta!',
    }
};
